import {
  Grid,
  TextField,
  FormControl,
  Typography
} from '@mui/material';
import { forwardRef, useEffect, useRef } from 'react';
import { DateRangePicker } from 'react-bootstrap-daterangepicker';
  import 'bootstrap-daterangepicker/daterangepicker.css';
  import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import moment from 'moment';
import { styled } from '@mui/styles';

interface DatePickerProps {
  title?: string;
  disable?: boolean,
  fromDate?: Date | null,
  toDate?: Date | null,
  onApply: (event, picker) => void,
  fullWidth?: boolean | null,
  mt?: number | null,
  disabled?: boolean,
  placeholder?: string,
  className?: string
}

const CalendarRangePicker = forwardRef((props: DatePickerProps, _ref) => {
  const myRef = useRef<DateRangePicker>();
  const dateStyle = {
    fontSize: '13px'
  };

  const getInitSettings = () => {
    const today = new Date();
    let settings = {
      startDate: moment(today).format('MM/DD/YYYY'),
      endDate: moment(today).format('MM/DD/YYYY'),
    };
    return settings;
  };

  const handleReset = () => {
    const today = new Date();
    myRef.current?.setStartDate(moment(today).format('MM/DD/YYYY'));
    myRef.current?.setEndDate(moment(today).format('MM/DD/YYYY'));
  };

  //date range value reset
  useEffect(() => {
    if (!(props.fromDate && props.toDate)) {
      handleReset();
    }
  }, [props.fromDate, props.toDate]);

  return (
    <FormControl className={props?.className ? props?.className : 'date-filter'} 
    fullWidth={props?.fullWidth}
      disabled={props?.disabled ? props?.disabled : false}>
      {props?.title && 
        <Typography fontWeight="light" variant="h5">
          {props?.title}<span style={{ color: 'red' }}>*</span>
        </Typography>
      }
      <Grid sx={{ mt: props.mt ? props?.mt : 1 }} position='relative'>
        <DateRangePicker
          ref={myRef}
          initialSettings={getInitSettings()}
          onApply={props?.onApply}
          onCancel={() => {
            handleReset();
          }}
        >
          <div style={{ position: 'relative' }}>
            <TextField

              disabled={props?.disabled ? props?.disabled : false}
              placeholder={props?.placeholder ? props?.placeholder : "DD/MM/YYYY - DD/MM/YYYY"}
              value={ (props?.fromDate && props?.toDate) ? 
                (props?.fromDate && moment(props?.fromDate).format('DD/MM/YYYY')) +
                    ' - ' +
                  (props?.toDate && moment(props?.toDate).format('DD/MM/YYYY'))
                : ''
              }
              id="date"
              fullWidth
              size="small"
              style={dateStyle}
              sx={{
                '& input::placeholder': {
                  color: 'rgba(34, 51, 84, 0.7)',
                  opacity: 1
                }
              }}
            />
            <CalendarTodayIcon
              className={props?.disabled ? "calendar-icon disable-icon" : "calendar-icon"}
              fontSize={'small'}
            />
          </div>
        </DateRangePicker>
      </Grid>
    </FormControl>
    
  );
});

export default CalendarRangePicker;
